var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footr"},[_c('div',{staticClass:"foo-wrapper"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("ComicHub")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }